// A "starter template" the user can load and overwrite from the UI, backed
// by the same /email/templates collection the Campaigns tab already uses
// (under a reserved name unique to that use — no new backend storage).
// Used by OutreachTab (pitch email + social message) and MarketsTab
// (stallholder pitch email).
import { useCallback, useEffect, useState } from 'react';
import { api } from './auth';

export function useSavedTemplate(name) {
  const [template, setTemplate] = useState(null); // null = no saved override yet
  const [saving, setSaving]     = useState(false);

  const load = useCallback(() => {
    api.get('/email/templates')
      .then(r => setTemplate((r.data || []).find(t => t.name === name) || null))
      .catch(() => {});
  }, [name]);

  useEffect(() => { load(); }, [load]);

  const save = async (subject, html) => {
    setSaving(true);
    try {
      const body = { name, subject, html };
      const { data } = template
        ? await api.put(`/email/templates/${template._id}`, body)
        : await api.post('/email/templates', body);
      setTemplate(data);
      return data;
    } finally {
      setSaving(false);
    }
  };

  return { template, saving, save };
}
